import { useQuery } from "@tanstack/react-query";

import {
  BoxedContent,
  Header,
  NoDataFound,
} from "@/components/common";

import { DynamicObjectTable } from "@/components/dynamic/object-manager";
import { getDynamicDashboardObjects } from "@/api/dynamic/dynamicDashboardViewApi";
import {
  getDynamicObjectColumns,
  getDynamicObjectData,
} from "@/components/dynamic/object-manager/dynamicObjectDashboardTableData";
import { skeletonLoadingRows } from "@/utils/helpers";

function DynamicDashboardObjectManager() {
  const { isLoading, data } = useQuery(
    ["dynamic-dashboard-objects"],
    getDynamicDashboardObjects
  );

  const renderTable = () => {
    if (!isLoading && data && !data?.data) {
      return (
        <NoDataFound
          title="No dashboard has been added"
        />
      );
    }

    return (
      <DynamicObjectTable
        data={getDynamicObjectData(data?.data || skeletonLoadingRows())}
        tableColumns={getDynamicObjectColumns(data?.data || [])}
        isLoading={isLoading}
      />
    );
  };

  return (
    <BoxedContent>
      <Header
        showBreadcrumb
        leftContent={<h1>Dashboard Object Manager</h1>}
      />
      {renderTable()}
    </BoxedContent>
  );
}

export default DynamicDashboardObjectManager;
